<template>
  <el-container direction="vertical">
    <el-row>
      <el-col :span="5">
        <el-input v-model="params.org_name" prefix-icon="el-icon-search" placeholder="输入客户名称查询" clearable @change="onSearch()" />
      </el-col>
      <el-col :span="4" v-if="isSystermRole">
        <el-select v-model="params.is_virtual" placeholder="全部客户类型" clearable @change="onSearch()" >
          <el-option
            v-for="item in virtuals"
            :key="item.value"
            :label="item.name"
            :value="item.value" />
        </el-select>
      </el-col>
      <el-col :span="5" class="col_pos_right" align="right">
        <el-button v-permission="'增加客户'" icon="el-icon-plus" @click="addUser()">添加客户</el-button>
        <el-button class="btn btn_1" @click="onSearch()">刷新</el-button>
      </el-col>
    </el-row>

    <el-container>
      <el-table :data="pageData.items" stripe border :height="$setTableHeight(1, 0)" :header-cell-style="{textAlign: 'center'}" :cell-style="{textAlign: 'center'}">
        <el-table-column v-for="it in tableColList" :key="it.key" :label="it.name" :fixed="it.fixed">
          <template slot-scope="scope">
            <span>{{scope.row[it.key]}}</span>
          </template>
        </el-table-column>

        <el-table-column fixed="right" width="180" label="操作">
          <template slot-scope="scope">
            <el-link v-for="item in $operationsFilter(operations)" :key="item.key" :type="item.type" @click="handleClick(item.key, scope.row)">{{ item.title }}</el-link>
          </template>
        </el-table-column>
      </el-table>
    </el-container>

    <el-pagination
      background
      style="margin-top:14px"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageData.total"
      :current-page="pageData.page"
      @current-change="onPageChange"
      :page-size="params.max_results"
      :page-sizes="$pageSizes"
      @size-change="onPageSizeChange">
    </el-pagination>

    <el-dialog width="600px" :title="title" :visible.sync="dialogVisible" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" @closed="componet_select = ''">
      <component :is="componet_select" :rowData="rowData" @tableCloseDialog="dialogVisible = false" />
    </el-dialog>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'
import BasicDataHelper from '@/api/basic_data_helper'
import customerAdd from './add'
import customerEdit from './edit'

export default {
  data () {
    const userRole = localStorage.user_roles
    return Backend.initListPage(this, 'org_customer', {
      route_name: '客户管理列表',
      id_name: 'org_id',
      tableColList: [
        {
          key: 'org_id',
          name: '客户ID',
          fixed: true
        },
        {
          key: 'org_name',
          name: '客户名称'
        },
        {
          key: 'org_contact_name',
          name: '联系人'
        },
        {
          key: 'org_contact_phone',
          name: '联系电话'
        },
        {
          key: 'org_contact_mail',
          name: '客户邮箱'
        }
      ],
      userRole: userRole,
      virtuals: BasicDataHelper.virtuals,
      params: {
        org_name: '',
        is_virtual: null
      },
      dialogVisible: false,
      title: '添加客户',
      componet_select: '',
      operations: [
        {
          key: 'edit',
          title: '编辑',
          icon: 'icon-bianji icon_1',
          type: 'primary',
          permiss: '编辑客户'
        },
        {
          key: 'delete',
          title: '删除',
          icon: 'icon-shanchu icon_6',
          type: 'danger',
          permiss: '删除客户'
        }
      ],
      rowData: {}
    })
  },
  components: {
    'customer-add': customerAdd,
    'customer-edit': customerEdit
  },
  computed: {
    isSystermRole () {
      return this.userRole === '0' || this.userRole === '1'
    }
  },
  methods: {
    addUser () {
      this.title = '添加客户'
      this.dialogVisible = true
      this.componet_select = 'customer-add'
    },
    onSearch () {
      Backend.queryList(this, this.pageData.filter, 0)
    },
    onPageChange (v) {
      Backend.queryList(this, this.pageData.filter, v)
    },
    onPageSizeChange (v) {
      this.params.max_results = v
      Backend.queryList(this, this.pageData.filter, this.pageData.page === 0 ? 1 : this.pageData.page)
    },
    handleClick (key, row) {
      if (key === 'edit') this.editRow(row)
      if (key === 'delete') this.deleteRow(row)
    },
    editRow (row) {
      this.title = '编辑客户'
      this.dialogVisible = true
      this.componet_select = 'customer-edit'
      this.rowData = row
    },
    deleteRow (row) {
      Backend.deleteRow(this, row, '客户管理')
    }
  }
}
</script>
